import { RATING_THRESHOLDS } from "@/pages/CreatorAnalytics/constants";

export const formatRatingPercent = (rating: number | null): string => {
  if (rating === null) {
    return "N/A";
  }
  return `${(rating * RATING_THRESHOLDS.PERCENTAGE_MULTIPLIER).toFixed(0)}%`;
};
